import { render, staticRenderFns } from "./OrderEditPage.vue?vue&type=template&id=27c4f6b0&scoped=true&"
import script from "./OrderEditPage.vue?vue&type=script&lang=js&"
export * from "./OrderEditPage.vue?vue&type=script&lang=js&"
import style0 from "./OrderEditPage.vue?vue&type=style&index=0&id=27c4f6b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c4f6b0",
  null
  
)

export default component.exports